module.exports = __webpack_public_path__ + "img/step4-08.fc75410e.jpg";